import StoreLayout from "../../../components/store-layout.js";

const Accessories = () => {
  return (
    <>
      <h1>3D Printed Aquarium Accessories</h1>
      <p>All 3D Printed Accessories are made with aquarium safe PTSG filament. </p>
      <StoreLayout type={"accessories"}/>
    </>
  )
}

export default Accessories